export const syncLogToShopify = async (type, value, metafieldKey) => {
  const user = JSON.parse(localStorage.getItem("hive_user"));
  const customerId = user?.id;

  const response = await fetch("/api/save-log", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ customerId, type, value, metafieldKey }),
  });

  console.error("Response from server:", response);
  return response.json();
};
